import React, { Component } from "react";

import DataTable from 'react-data-table-component';

import $ from "jquery";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage:true
};
export default class Rueda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRueda: [],
    };
  }

  componentDidMount() {
   
  }


  getColumn() {
    return [
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "30px",
      },
      {
        name: "Descripción",
        selector: row => row.descripcion,
        width: "180px",
      },
      {
        name: "Depositado",
        selector: row => row.depositado,
        width: "150px"
      },
      {
        name: "Grupo",
        selector: row => row.idGrupo,
        width: "80px"
      },
      {
        name: "Nro. Contrato",
        selector: row => row.contrato,
        width: "150px",
        right: true
      },
      {
        name: "Plazo",
        selector: row => row.plazo,
        width: "110px",
        right: true
      },
      {
        name: "Cta. Ahorro - Grupo",
        selector: row => row.grupo,
        width: "150px",
        right: true
      }
      
    ];
  }


  selGrupoEvt = (e) => {

    this.rueSele = e.currentTarget;
    /*console.log("selecciona "+e.currentTarget)*/
    //console.log("el valor de rueda " + e)
    //console.log("el valor de rueda " + this.rueSele.id)
    var id=""

    for (var i = 0; i < this.props.ruedas.length; i++) {
      var rue = this.props.ruedas[i]
      var rue_id = "radio_" + rue.id;
      if (rue_id === this.rueSele.id) {
        this.props.datoRueda(rue.depositado, rue.cuentaAhorro, rue.credito, rue_id);
      }
    }
    this.enableNext();
  };
  enableNext() {

    this.checkGrilla();
  }

  checkGrilla() {
    //console.log("en check " + this.rueSele)
    if (this.rueSele !== undefined) {
      $("#" + this.rueSele.id).prop("checked", true);
    }
  
  }

  seleccionarFila(row){
    this.rueSele = document.getElementById("radio_" + row.id);
    this.props.datoRueda(row.depositado, row.cuentaAhorro, row.credito);
   
  }

  obtenerRuedas() {
  
    //console.log(this.props.ruedas)
    if (this.props.ruedas !== undefined && this.props.ruedas.length === 0)
    return (
      <div>
        <span />
      </div>
    )
        return(
          <div>
            <div className="row"> 
              <div className="col-lg-12">
                <label className="input-label-bold">
                  Seleccione la Rueda *
                </label>
                <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  pagination={true}
                  columns={this.getColumn()}
                  data={this.props.ruedas}
                  dense={true}
                  pagination={true}
                  paginationComponentOptions={paginationOptions}
                  noDataComponent="no hay registros para mostrar"
                  responsive={true}
                  striped={true}
                  pointerOnHover
                  onRowClicked={(e)=>this.seleccionarFila(e)}/>                       
                </div>   
              </div>                       
            </div> 
          </div>  
        )
  }
  

  render() {
    return (
      <div>
        <hr/>
        <div className="form-group">
          {this.obtenerRuedas()}
        </div>
      </div>
    );
  }
}
